import { store } from '@/store'
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import { mapPackagingTypeTypeToApi } from '@/mappers/receiving/draft/packagingType'
import { CreateWarehouseReceivingOrderService } from '@/services/createWarehouseReceivingOrder/index'
import { saveWro } from '@/models/createWarehouseReceivingOrder/commonActions/index'
import { machine } from '@/models/createWarehouseReceivingOrder/create-order-machine'
import { skuTypeEnum } from '@/enums/modules/creatingWarehouseReceivingOrder/skuType'

export const reset = () => {
  const isWroCreated = store.getters[ModuleName + '/isWroCreated']
  if (!isWroCreated) {
    resetPackagingTypeInStore()
    resetSKUTypeInStore()
    resetLabelPurchaseInStore()
    resetOriginAddressInStore()
  } else if (isWroCreated) machine.transition('EDIT_WRO_LOCKED')
}

export const resetPackagingTypeInStore = () => store.dispatch(ModuleName + '/resetSelectedPackagingType')

export const savePackagingType = async (_state, _draft) => {
  if (!_draft) {
    return
  }
  machine.visited.delete(4) // remove shipping configuration step from visited set to force checking whether it is single or multi sku
  const res = await saveWro({ mapper: mapPackagingTypeTypeToApi, service: CreateWarehouseReceivingOrderService.updateShippingType })(_state, _draft)
  if (res.success) {
    const furthestCompletedStep = store.getters[ModuleName + '/furthestCompletedStep']
    if (furthestCompletedStep >= 5) {
      store.dispatch(ModuleName + '/setFurthestCompletedStep', 4)
    }
    store.dispatch(ModuleName + '/setPricingGroup', null)
    const isWroCreated = store.getters[ModuleName + '/isWroCreated']
    if (!isWroCreated) store.dispatch(ModuleName + '/resetEstimatedDateOfArrival')
  }
}

export const checkLabelValues = () => {
  const val = store.getters[ModuleName + '/selectedLabelPurchaseType'].id
  if (val === 1) {
    const address = store.getters[ModuleName + '/originAddress']
    if (address && address.name && address.streetAddress1 && address.city && address.state && address.zipCode) {
      machine.transition('ADDRESS_ADDED')
    } else machine.transition('ADDRESS_NOT_ADDED')
  } else machine.transition('ADDRESS_ADDED')
}

export const setHasBeenEditedFlag = (val) => () => store.dispatch(ModuleName + '/setSelectedProductsEdited', val)

export const resetSKUTypeInStore = () => store.dispatch(ModuleName + '/resetSelectedSKUType')

export const resetLabelPurchaseInStore = () => store.dispatch(ModuleName + '/resetSelectedLabelPurchaseType')

export const resetOriginAddressInStore = () => store.dispatch(ModuleName + '/resetOriginAddress')

export const autofillSKUTypeIfNecessary = () => {
  const isfloorLoadedContainerWithNoMultipleLots = store.getters[ModuleName + '/floorLoadedContainerWithNoMultipleLots']
  const selectedProductCount = store.getters[ModuleName + '/selectedProducts'].length
  if (isfloorLoadedContainerWithNoMultipleLots) {
    if (selectedProductCount > 1) {
      store.dispatch(ModuleName + '/setSelectedSKUType', { id: skuTypeEnum.MultipleSKUPerContainer })
    } else {
      store.dispatch(ModuleName + '/setSelectedSKUType', { id: skuTypeEnum.OneSKUPerContainer })
    }
  }
}
